export enum RateType {
  Hourly = 'Hourly',
  Fixed = 'Fixed',
}

export enum RateStatus {
  Active = 'Active',
  Archived = 'Archived',
  All = 'All',
}

export interface IRate {
  id: string;
  idUser: string;
  name: string;
  description: string;
  amountExclGst: number;
  amountGst: number;
  amountInclGst: number;
  rateType: string;
  status: RateStatus.Active | RateStatus.Archived;

  expanded: boolean;
}
